module.exports = __webpack_public_path__ + "static/22-Changes-88043ffe2a7e7c378d21c590f6d9ab07.png";